/**
 * Declare border-related tokens etc. here so that the values can be generated for both PrimeNG & TailwindCSS
 */
export const borderRadius = {
  none: '0',
  xs: '2px',
  sm: '4px',
  md: '8px',
  lg: '16px',
  xl: '24px',
  full: '9999px'
};